import { IDeviceReassignmentDTO, ISamReassignmentDTO } from '../../../interfaces/interfaceReassignment';
import {
    GET_REASSIGNMENT,
    GET_REASSIGNMENT_SUCCESS,
    GET_REASSIGNMENT_ERROR,
} from '../../../constants/reassignment';

interface ISamTypeData {
  data: ISamReassignmentDTO[] | IDeviceReassignmentDTO[];
  loading: boolean;
  error: any;
}

const SamTypeData: ISamTypeData = {
  data: [],
  loading: false,
  error: null,
}

export const getReassignment = (state: ISamTypeData = SamTypeData, actions: any) => {
  switch (actions.type) {
    case GET_REASSIGNMENT:
      return {
        ...state,
        loading: true,
      };
    case GET_REASSIGNMENT_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case GET_REASSIGNMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
